import React from "react";
import clsx from "clsx";
import {createUseStyles} from "react-jss";
import {Theme} from "engage-client/theme";

const useStyles = createUseStyles<Theme>((theme) => ({
	questionCounter: {
		display: "flex",
		justifyContent: "center"
	},
	number: {
		width: 40,
		height: 40,
		boxSizing: "border-box",
		borderRadius: 20,
		fontSize: 20,
		color: theme.questionProgress.box?.color ?? "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		margin: [0,8],
		[theme.breakpoints.only("lg")] : {
			width: 30,
			height: 30,
			margin: [0,4],
			fontSize: 16,
			borderRadius: 20,
			lineHeight: "1px", //force the text to be centered vertically
		},
		[theme.breakpoints.only("sm")] : {
			width: 30,
			height: 30,
			margin: [0,4],
			fontSize: 16,
			borderRadius: 20,
			lineHeight: "1px", //force the text to be centered vertically
		},
		[theme.breakpoints.down("xs")] : {
			width: 18,
			height: 18,
			margin: [0,2],
			fontSize: 10,
			borderRadius: 10,
			lineHeight: "1px", //force the text to be centered vertically
		}
	},
	box: {
		[theme.breakpoints.down("xs")] : {
			borderWidth: 1
		},
		fontWeight: 700
	},
	pastBox : {
		backgroundColor: theme.questionProgress.pastBox.backgroundColor,
		color: theme.questionProgress.pastBox.color ?? "white",
	},
	currentBox: {
		backgroundColor: theme.questionProgress.currentBox.backgroundColor,
		color: "black",
		[theme.breakpoints.only("lg")] : {
			borderWidth: 3
		},
		[theme.breakpoints.only("sm")] : {
			borderWidth: 3
		},
		[theme.breakpoints.down("xs")] : {
			borderWidth: 2
		}
	},
	dotdot: {
		margin: 0,
		width: "auto",
	},

}));

export interface QuestionCounterProps {
	totalQuestions: number
	currentQuestion: number
	className?: string
}

export default function QuestionCounter({totalQuestions, currentQuestion, className}:QuestionCounterProps) {
	const classes = useStyles();

	let start = Math.max(currentQuestion - 4, 1);
	const last = Math.min(start + 8, totalQuestions);
	//Make sure we show at least 10 boxes.
	if(last === totalQuestions) {
		start = Math.max(last - 9, 1);
	} else {
		start = Math.max(last - 8, 1);
	}

	let counterBoxes = [];
	for(let num = start; num <= last; num++) {
		if(num === currentQuestion) {
			counterBoxes.push(<div key={num} className={clsx(classes.number, classes.box,classes.currentBox)}>{num}</div>);
		} else {
			counterBoxes.push(<div key={num} className={clsx(classes.number, classes.box, num < currentQuestion && classes.pastBox)}>{num}</div>);
		}
	}
	if(last < totalQuestions - 1) {
		counterBoxes.push(<div key=".." className={clsx(classes.number, classes.dotdot)}>..</div>);
	}
	if(last < totalQuestions) {
		counterBoxes.push(<div key="last" className={clsx(classes.number, classes.box)}>{totalQuestions}</div>);
	}

	return <div className={clsx(classes.questionCounter, className)} data-qa="question-counter" data-value={currentQuestion}>
		{counterBoxes}
	</div>;
}